import React from 'react';
import Input, { TYPE_PASSWORD } from 'components/Form/Input';

export default function Password(props)
{
  return <Input type={TYPE_PASSWORD} {...props} />
}
